import React, { useState } from "react";
import { motion } from "framer-motion";
import classes from "./PrepareTop.module.scss";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import charJumpImage from "../../static/images/prepare/char-jump.png";
import topHeader1 from "../../static/images/prepare/prepare-top-header-1.png";
import topHeader2 from "../../static/images/prepare/prepare-top-header-2.png";
import topHeader3 from "../../static/images/prepare/prepare-top-header-3.png";
import topImageTitle1 from "../../static/images/prepare/topImageTitle1.png";
import topImageTitle2 from "../../static/images/prepare/topImageTitle2.png";
import topImageTitleBg1 from "../../static/images/prepare/topImageTitleBg1.png";
import topImageTitleBg2 from "../../static/images/prepare/topImageTitleBg2.png";
import topImageEducation from "../../static/images/prepare/topImageEducation.png";
import topImageLifeplan from "../../static/images/prepare/topImageLifeplan.png";
import topImageExplanation from "../../static/images/prepare/topImageExplanation.png";
import { useLoginStatus } from "../../common/hooks/useLoginStatus";
import Header from "../../molecules/header/Header";

function PrepareTop() {
  const navigate = useNavigate();
  const { isLoggedIn } = useLoginStatus();

  // ---- アニメ共通設定 ----
  const STEP = 0.5;                 // 0.5秒刻み
  const DUR  = 0.5;                 // 各要素のスライド時間
  const DELAY_BG1       = STEP * 1; // 0.5s
  const DELAY_BG2       = STEP * 2; // 1.0s
  const DELAY_BG_FILL   = STEP * 2.5;
  const DELAY_LOGOS     = STEP * 3; // 1.5s
  const DELAY_EXPL      = STEP * 4; // 2.0s
  const DELAY_COMMENTS  = STEP * 5; // 2.5s
  const DELAY_BUTTON    = STEP * 6; // 3.0s

  const slideFromBottom = (delay: number, duration = DUR) => ({
    initial: { y: "100%", opacity: 0 },  // ← 100vh ではなく 100%
    animate: { y: 0, opacity: 1 },
    transition: { delay, duration, ease: "easeOut" as const },
  });

  const handleCloseStart = () => {
    navigate("/familynavi/diagnosis");
  };

  return (
    <div className={classes.container}>
      {isLoggedIn && <Header />}

      <div className={classes.body}>
        {/* 初期表示：上部ヘッダー画像 */}
        <div className={classes.topHeaderContainer}>
          {isLoggedIn === false && (
            <div className={classes.row1}>
              <img src={topHeader1} alt="備えナビ トップヘッダー1" />
            </div>
          )}
          <div className={classes.row2}>
            <img src={topHeader2} alt="備えナビ トップヘッダー2" />
            <img src={topHeader3} alt="備えナビ トップヘッダー3" />
          </div>
        </div>
        {/* タイトル2つは“即時表示” */}
        <div className={classes.backgroud}>
          {/* ← 背景色だけを動かす“下地レイヤー” */}
          <motion.div
            className={classes.bgFill}
            {...slideFromBottom(DELAY_BG_FILL)}
          />
          <div className={classes.imageStack}>
            <img className={classes.topImage} src={topImageTitle1} alt="タイトル1" />
            {/* 0.5秒後に下からスライドイン */}
            <motion.img
              className={classes.topImageBg1}
              src={topImageTitleBg1}
              alt="タイトル背景1"
              {...slideFromBottom(DELAY_BG1)}
            />
          </div>

          <div className={classes.imageStack}>
            <img className={classes.topImage} src={topImageTitle2} alt="タイトル2" />
            {/* さらに0.5秒後（合計1.0秒）に下からスライドイン */}
            <motion.img
              className={classes.topImageBg2}
              src={topImageTitleBg2}
              alt="タイトル背景2"
              {...slideFromBottom(DELAY_BG2)}
            />
          </div>
          {/* さらに0.5秒後（合計1.5秒）：ロゴ群を下から */}
          <div className={classes.logoRow}>
            {/* 教育ロゴ */}
            <motion.img
              className={classes.imageLogo}
              src={topImageEducation}
              alt="教育ロゴ"
              {...slideFromBottom(DELAY_LOGOS)}
            />

            {/* ライフプランロゴ：0.2秒遅らせる */}
            <motion.img
              className={classes.imageLogo}
              src={topImageLifeplan}
              alt="ライフプランロゴ"
              {...slideFromBottom(DELAY_LOGOS + 0.2)}
            />
          </div>
        </div>

        {/* さらに0.5秒後（合計2.0秒）：説明ロゴ */}
        <motion.img
          className={classes.explnationLogo}
          src={topImageExplanation}
          alt="説明ロゴ"
          {...slideFromBottom(DELAY_EXPL)}
        />

        {/* さらに0.5秒後（合計2.5秒）：コメント3行（ひとかたまりで下から） */}
        <motion.div {...slideFromBottom(DELAY_COMMENTS)}>
          <div className={classes.orangeComment}>みらいい認定FPが監修</div>
          <div className={classes.orangeComment}></div>
          <div className={classes.blackComment}>※金融商品の勧誘は一切ございません。</div>
          <div className={classes.blackComment}>※無料・匿名で利用できます。</div>
        </motion.div>

        {/* さらに0.5秒後（合計3.0秒）：ボタンエリア */}
        <motion.div
          className={classes.buttonArea}
          onClick={handleCloseStart}
          {...slideFromBottom(DELAY_BUTTON)}
        >
          <img className={classes.char} src={charJumpImage} alt="キャラ ジャンプ" />
          <div className={classes.button}>さっそくはじめる！</div>
        </motion.div>
        {/* パンくず */}
        {isLoggedIn ? (
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/top" },
              { displayName: "家族の備えナビ", url: "/familynavi" },
            ]}
          />
        ) : (
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/top" },
              { displayName: "家族の備えナビ", url: "/familynavi" },
            ]}
          />
        )}
      </div>
    </div>
  );
}

export default PrepareTop;
